import { each } from 'lodash';
import { getCookie } from '../../core/utils';
riot.tag2('raq-form', '<yield></yield>', '', '', function(opts) {
  /* global Acr */

  const params = require('../../core/params');
  const quoterequest = require('../../core/quoterequest');
  const ERRORS = require('../../core/platform/errors.js').default;
  const CONSTANTS = require('../../core/platform/constants.js').default;
  const undecidedPackageLabel = window.raq.labels.vehicleSelector.undecided;
  const acrModalSelectorClass = '.js-acr-modal';
  const acrRaqModalSelectorClass = '.acr-modal.modal-raq';

  require('es6-promise').polyfill();

  this.mixin('bus');
  this.mixin('storage');

  const self = this;
  self.form = self.root;
  self.formValid = false;
  self.submitDisabled = true;
  self.cityStateUpdated = false;

  self.trackingHandler = require('../../core/trackingManager');

  let $selectPackageDropdown;

  function isValidJson(json) {
    try {
      JSON.parse(json);
      return true;
    } catch (e) {
      return false;
    }
  }

  function hypensname(str) {
    if (str) {
      return str.toLowerCase().replace(/\s/g, '-');
    }
    return undefined;
  }

  function getUserobject() {
    const formFields = {};
    each(self.form.elements, (el) => {
      if (el.value && el.value !== '') {
        const fieldName = el.name.replace(/-([a-z])/g, (g) => {
          const replace = g[1].toUpperCase();
          return replace;
        });
        formFields[fieldName] = el.value;
      }
    });

    if (!formFields.zipcode) {
      // If no zipcode field present,
      // get FallbackZipCode from cookie/dealer params.getFallbackZipCode();
      formFields.zipcode = params.getFallbackZipCode();
    }

    const campaignnameCMS = window.raq && window.raq.marketingCampaign
      ? window.raq.marketingCampaign : '';
    const campaignName = getCookie('campaignName') || campaignnameCMS;

    // If window.BaP exists then send the accessories in the quote
    let accessories = self.storage.session.get(CONSTANTS.accessoriesStorageKey);
    accessories = accessories && isValidJson(accessories) && window.BaP
      ? JSON.parse(accessories) : null;

    // Send Ignition One's Engagement Score in RAQ leads.
    const additionalInfo = [];
    if (window.iOneACURACustomData && window.iOneACURACustomData[0].ioScore) {
      const engagementScore = {
        key: CONSTANTS.engagementScoreKey,
        value: window.iOneACURACustomData[0].ioScore,
      };

      additionalInfo.push(engagementScore);
    }

    const userObj = {
      accessories,
      vehicleModelSeries: hypensname(self.userData.carModelName),
      modelMarketingName: self.userData.modelMarketingName,
      modelYear: self.userData.carModelYear,
      exteriorColorCode: self.userData.exteriorColorCode,
      exteriorColorName: self.userData.exteriorColorName,
      exteriorColorIdent: self.userData.exteriorColorIdent,
      interiorColorCode: self.userData.interiorColorCode,
      interiorColorName: self.userData.interiorColorName,
      interiorColorIdent: self.userData.interiorColorIdent,
      extraData: self.userData.extraData,
      dealerId: self.userData.localDealerId,
      localDealerName: self.userData.localDealerName,
      modelId: self.userData.modelId,
      offerId: self.userData.offerId,
      source: self.userData.source,
      zipCode: self.userData.userZipCode,
      undecidedPackage: self.userData.undecidedPackage,
      campaignName,
      shoppingTool: window.raq && window.raq.shoppingTool ? window.raq.shoppingTool : '',
      provider: window.raq && window.raq.provider ? window.raq.provider : '',
      tracking: {
        campaignName,
        shoppingTool: window.raq && window.raq.shoppingTool ? window.raq.shoppingTool : '',
      },
      addressScrubbing: window.raq && window.raq.addressScrubbing ? window.raq.addressScrubbing : false,
      userInfo: formFields,
      leadAdditionalInfo: additionalInfo,
    };

    return userObj;
  }

  function validateUserData() {
    self.userData = params.userData();
    const userData = getUserobject();
    let result = false;
    let packageRequired = checkPackageRequiredClass();
    if (userData && userData.dealerId && userData.modelYear && userData.vehicleModelSeries && userData.modelMarketingName && !packageRequired) {
      result = true;
    } else if (userData && userData.dealerId && userData.modelYear && userData.vehicleModelSeries && userData.modelMarketingName && packageRequired && userData.modelId) {
      result = true;
    } else {
      self.bus.trigger(self.bus.EVENTS.FORM.REQUIRED_FIELD, userData);
    }
    if (result && userData.modelId === undecidedPackageLabel) {
      params.setUndecidedPackage(undecidedPackageLabel);
      params.setVehicleModelId(null);
    }
    return result;
  }

  // Function to check if the package dropdown is required
  function checkPackageRequiredClass() {
    if ($selectPackageDropdown && $selectPackageDropdown.getAttribute('required')) {
      return true;
    }
    return false;
  }

  // Function to scroll top when validation returns errors
  function scrollToTop() {
    let $acrModal = document.querySelector(acrModalSelectorClass) || document.querySelector(acrRaqModalSelectorClass);
    if ($acrModal) {
      $acrModal.scrollTop = 0;
    } else {
      window.scrollTo(0, 0);
    }
  }

  function checkJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  function handleFieldError(field) {
    const errDiv = document
      .getElementsByClassName(`raq-form-error ${field.getAttribute('name')}`)[0];
    const errMsgRequired = field.getAttribute('data-error-required');
    const errMsgFormat = field.getAttribute('data-error-format');
    if (errDiv && errMsgFormat && field.value !== '') {
      errDiv.innerHTML = errMsgFormat;
    } else if (errDiv && errMsgRequired) {
      errDiv.innerHTML = errMsgRequired;
    }

    self.trackingHandler.submitErrorTracking(field.getAttribute('name'));

    field.parentElement.classList.add('error');
    console.warn(`Invalid field: ${field.name}`);
  }

  self.validateForm = () => {
    let result = true;
    let zipElement;
    const validUserData = validateUserData();

    if (!validUserData) {
      result = false;
    }
    self.update();

    each(self.form.elements, (el) => {
      const regString = el.getAttribute('data-regexkey');
      const regExp = new RegExp(regString);
      const isRequired = el.hasAttribute('required');

      el.parentElement.classList.remove('error');

      if (isRequired && el.value === '') {
        result = false;
      }

      if (regString) {
        if (regString === '[zipcode]') {
          zipElement = el;
        } else if (!regExp.test(el.value)) {
          result = false;
          handleFieldError(el);
        }
      } else if (isRequired && el.type === 'checkbox' && el.checked === false) {
        result = false;
        handleFieldError(el);
      }
    });

    if (zipElement) {
      /* eslint-disable no-inner-declarations */
      function validZipcodeSubmit() {
        if (result) {
          self.sendForm();
        }
      }

      function invalidZipcodeError() {
        handleFieldError(zipElement);
      }
      /* eslint-enable no-inner-declarations */

      window.Utility.validateZipcode(zipElement.value, validZipcodeSubmit, invalidZipcodeError);
    }

    if (!result) {
      self.bus.trigger(self.bus.EVENTS.FORM.SHOW_GLOBAL_ERROR, result);
      scrollToTop();
    }
  };

  self.sendForm = () => {
    self.trackingHandler.formSubmitButton();
    self.userData = params.userData();

    if (!self.endpoints.quoteRequestEndpoint) {
      window.console.warn(ERRORS.noEndpoint);
      return false;
    }
    self.submitDisabled = true;
    self.update();
    quoterequest.sendRaq(self.endpoints.quoteRequestEndpoint, getUserobject())
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          self.bus.trigger(self.bus.EVENTS.CONTAINER.CHANGESTATE, {
            state: 'is-success',
            title: response.data && response.data.confirmationTitle
              ? response.data.confirmationTitle : null,
            copy: response.data && response.data.confirmationCopy
              ? response.data.confirmationCopy : null,
            ctas: response.data && response.data.confirmationCTAs
              ? response.data.confirmationCTAs : null,
          });
          self.trackingHandler.sendTrackingSuccess();
        }
        self.submitDisabled = false;
        self.update();
      })
      .catch((error) => {
        if (error.response && error.response.data && error.response.data.ModelState) {
          // BE basic validation errors
          const state = error.response.data.ModelState;
          window.console.warn(ERRORS.badRequest, state);

          if (state.quoteRequest && state.quoteRequest.UserInfo
            && state.quoteRequest.UserInfo.Email) {
            handleFieldError(self.form.elements.email); // Handle email error
          }

          if (state.quoteRequest && state.quoteRequest.UserInfo
            && state.quoteRequest.UserInfo.Address) {
            handleFieldError(self.form.elements.address); // Handle email error
          }

          if (state.quoteRequest && state.quoteRequest.UserInfo
            && state.quoteRequest.UserInfo.ZipCode) {
            handleFieldError(self.form.elements.zipcode); // Handle zipcode error
          }
        } else if (error.response && error.response.data && error.response.data.Message) {
          // BE endpoint validation  errors
          window.console.warn(ERRORS.badRequest, error.response.data.Message);
          const message = checkJson(error.response.data.Message) ? JSON.parse(error.response.data.Message) : null;
          const errorId = error.response.data.ErrorId;
          const statusCode = error.response.data.StatusCode;
          // Handling 2 different error responses for BLOCKED_EMAIL
          if ((message && message.ErrorId && message.ErrorId === 'BLOCKED_EMAIL')
              || (errorId && errorId === 'BLOCKED_EMAIL')) {
            handleFieldError(self.form.elements.email); // Handle email error
          } else if (errorId && errorId === 'INVALID_ADDRESS') {
            handleFieldError(self.form.elements.address); // Handle address error
          } else if (statusCode === 422) { // Handle no lead id generic error
            self.bus.trigger(self.bus.EVENTS.CONTAINER.CHANGESTATE, { state: 'is-error' });
          }
        } else {
          // Not specified error
          window.console.warn(ERRORS.endpointFailed, error.message);
          self.bus.trigger(self.bus.EVENTS.CONTAINER.CHANGESTATE, { state: 'is-error' });
        }

        // 500 error scenario
        if (error && error.response && error.response.status && error.response.status >= 500) {
          window.console.warn(ERRORS.endpointFailed, error.response);
          self.bus.trigger(self.bus.EVENTS.CONTAINER.CHANGESTATE, { state: 'is-error' });
        }
        self.submitDisabled = false;
        self.update();
      });

    const offset = document.querySelector('.acr-nav').getBoundingClientRect().height;
    const scrollDepth = (self.root.parentNode.getBoundingClientRect().top
      + window.pageYOffset) - offset;
    window.scrollTo(0, scrollDepth);
    return false;
  };

  function checkSend() {
    if (self.triggerSend) {
      self.triggerSend = false;
      self.sendForm();
    }
  }

  function sendAbandonTracking() {
    window.removeEventListener('beforeunload', sendAbandonTracking);
    window.removeEventListener('closeRaq', sendAbandonTracking);
    self.trackingHandler.abandonTracking();
  }

  window.addEventListener('beforeunload', sendAbandonTracking);
  window.addEventListener('closeRaq', sendAbandonTracking);

  self.on('mount', () => {
    $selectPackageDropdown = document.querySelector('#raq-package-selector-dropdown');
  });

  self.bus.on(self.bus.EVENTS.FORM.ADDRESS_AUTOCOMPLETED, checkSend);
});
